import { c as _c } from "react/compiler-runtime";
import { Facet, FacetRange, FacetValue, SelectedFacet } from '../interfaces';
import React, { ChangeEvent, ReactElement, useDeferredValue, useState } from 'react';
import CheckboxComponent from '../../checkbox/checkbox.component';
import ColorCheckboxComponent from './color-checkbox/color-checkbox.component';
import { CurrencyIso } from '@spa/lib/converters/convertCurrencyIso';
import ImageComponent from '@spa/components/image-component/image.component';
import MultiRangeSliderComponent from '../../multi-range-slider/multiRangeSlider.component';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { PageType } from '@spa/lib/tracking/getPageType';
import classNames from 'clsx';
import { deriveFilterElement } from '../filterActionTracking';
import getCurrencySymbol from '../../../lib/getCurrencySymbol';
import selectCurrencyIso from '../../../lib/store/settings/selectors/selectCurrencyIso';
import styles from './facet.component.module.scss';
import { tracker } from '@spa/lib/tracking/tracker';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
import { useSelector } from 'react-redux';
enum RangeFacetValueType {
  MIN = 'min',
  MAX = 'max',
}
export interface Props {
  readonly facet: Facet;
  readonly isClosed: boolean;
  readonly onFacetRangeChange: (facetCode: string, min: number, max: number) => void;
  readonly onFacetValueChange: (facetValueCode: string, facet: Facet) => void;
  readonly pageType: PageType;
  readonly selectedFacet?: SelectedFacet;
}
function FacetComponent(t0) {
  const $ = _c(37);
  const {
    facet,
    isClosed,
    onFacetRangeChange,
    onFacetValueChange,
    pageType,
    selectedFacet
  } = t0;
  const [isExpanded, setIsExpanded] = useState(!isClosed);
  const currencyIso = useSelector(selectCurrencyIso);
  const [searchInput, setSearchInput] = useState("");
  const searchQuery = useDeferredValue(searchInput);
  const {
    formatMessage
  } = useNamespacedIntl("facet");
  const t1 = `facetNames.${facet.facetCode}`;
  let t2;
  if ($[0] !== formatMessage || $[1] !== t1) {
    t2 = formatMessage(t1);
    $[0] = formatMessage;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const facetName = t2;
  let t3;
  if ($[3] !== selectedFacet) {
    t3 = selectedFacet !== undefined && selectedFacet.type !== "range" ? new Set(selectedFacet.values.map(_temp)) : new Set();
    $[3] = selectedFacet;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const selectedCodes = t3;
  let t4;
  if ($[5] !== currencyIso || $[6] !== facet || $[7] !== facetName || $[8] !== formatMessage || $[9] !== isExpanded || $[10] !== onFacetRangeChange || $[11] !== onFacetValueChange || $[12] !== pageType || $[13] !== searchInput || $[14] !== searchQuery || $[15] !== selectedCodes || $[16] !== selectedFacet) {
    const sortedBrandValues = facet.type === "values" && facet.facetCode === "brand.name" ? [...facet.values].sort(_temp2) : [];
    let t5;
    if ($[18] !== selectedFacet) {
      t5 = function getSelectedRangeValue(t6, value) {
        const {
          from,
          to
        } = t6;
        const isMin = value === RangeFacetValueType.MIN;
        const hasSelectedRange = selectedFacet !== undefined && selectedFacet.type === "range";
        const min = hasSelectedRange ? Math.max(selectedFacet.from, from) : from;
        const max = hasSelectedRange ? Math.min(selectedFacet.to, to) : to;
        return isMin ? min : max;
      };
      $[18] = selectedFacet;
      $[19] = t5;
    } else {
      t5 = $[19];
    }
    const getSelectedRangeValue = t5;
    const getFilteredValues = function getFilteredValues() {
      let result = facet.type !== "range" ? facet.values : [];
      if (facet.type === "values" && facet.facetCode === "brand.name") {
        const lower = searchQuery.toLowerCase();
        result = lower ? sortedBrandValues.filter(t6 => {
          const {
            value: value_0
          } = t6;
          return value_0.toLowerCase().includes(lower);
        }) : sortedBrandValues;
      } else {
        if (facet.type === "boolean") {
          result = facet.values.filter(_temp3);
        }
      }
      return result;
    };
    let t7;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = function isBooleanValue(facetValue) {
        return facetValue === "true" || facetValue === "false";
      };
      $[20] = t7;
    } else {
      t7 = $[20];
    }
    const isBooleanValue = t7;
    let t8;
    if ($[21] !== facetName || $[22] !== pageType) {
      t8 = event => {
        const term = event.target.value;
        setSearchInput(term);
        tracker.filterAction({
          filter_category: facetName,
          filter_element: "suche",
          filter_interaction: "apply",
          filter_value: term,
          page_type: pageType
        });
      };
      $[21] = facetName;
      $[22] = pageType;
      $[23] = t8;
    } else {
      t8 = $[23];
    }
    const handleSearchChange = t8;
    let t9;
    if ($[24] !== facet || $[25] !== facetName || $[26] !== isExpanded || $[27] !== pageType) {
      t9 = () => {
        const nextExpanded = !isExpanded;
        setIsExpanded(nextExpanded);
        tracker.filterAction({
          filter_category: facetName,
          filter_element: deriveFilterElement(facet),
          filter_interaction: nextExpanded ? "open" : "close",
          filter_value: "",
          page_type: pageType
        });
      };
      $[24] = facet;
      $[25] = facetName;
      $[26] = isExpanded;
      $[27] = pageType;
      $[28] = t9;
    } else {
      t9 = $[28];
    }
    const handleExpandToggle = t9;
    let t10;
    if ($[29] !== isExpanded) {
      t10 = classNames(styles.facet, {
        [styles["facet--expanded"]]: isExpanded
      });
      $[29] = isExpanded;
      $[30] = t10;
    } else {
      t10 = $[30];
    }
    const t11 = `facet-options-${facet.facetCode}`;
    let t12;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <ImageComponent src="/assets/icons/arrow_forward_bold.svg" height={13.5} width={13.5} alt="" className={styles["facet__facet-button-arrow"]} aria-hidden="true" />;
      $[31] = t12;
    } else {
      t12 = $[31];
    }
    let t13;
    if ($[32] !== facetName || $[33] !== handleExpandToggle || $[34] !== isExpanded || $[35] !== t11) {
      t13 = <button className={`${styles["facet__facet-button"]} text-xl-immutable bold`} aria-expanded={isExpanded} aria-controls={t11} onClick={handleExpandToggle}>{facetName}{t12}</button>;
      $[32] = facetName;
      $[33] = handleExpandToggle;
      $[34] = isExpanded;
      $[35] = t11;
      $[36] = t13;
    } else {
      t13 = $[36];
    }
    t4 = <div className={t10} aria-label={facetName}>{t13}{isExpanded && <div className={styles["facet__facet-content"]}>{facet.facetCode === "brand.name" && <div className={styles["facet__brand-searchbar"]}><input type="search" placeholder={formatMessage("searchTerm")} value={searchInput} onChange={handleSearchChange} className={styles["facet__search-input"]} /><ImageComponent className={styles["facet__search-icon"]} src="/assets/icons/search.svg" alt="search icon" width={20} height={20} /></div>}<ul id={`facet-options-${facet.facetCode}`} className={styles["facet__facet-list"]} aria-label={facetName}>{facet.type === "range" ? <li className={styles["facet__facet-option"]}><MultiRangeSliderComponent key={`${facet.facetCode}-${getSelectedRangeValue(facet, RangeFacetValueType.MIN)}-${getSelectedRangeValue(facet, RangeFacetValueType.MAX)}`} min={facet.from} max={facet.to} selectedMin={getSelectedRangeValue(facet, RangeFacetValueType.MIN)} selectedMax={getSelectedRangeValue(facet, RangeFacetValueType.MAX)} onChange={onFacetRangeChange} value={facet.facetCode} label={facetName} quantitySymbol={getCurrencySymbol(currencyIso)} /></li> : getFilteredValues().map(t14 => {
            const {
              code,
              count,
              value: value_2
            } = t14;
            const Component = facet.facetCode === "mainColor" ? ColorCheckboxComponent : CheckboxComponent;
            const selected = selectedCodes.has(code);
            return <li key={`${facet.facetCode}:${code}`} className={classNames(styles["facet__facet-option"], {
              [styles[`facet__facet-option--${code}`]]: facet.facetCode === "mainColor"
            })}><Component id={`${facet.facetCode}-${code}`} name={`${facet.facetCode}:${code}`} value={value_2} checked={selected} label={<span className={classNames(styles["facet__facet-option-label"], {
                [styles["facet__facet-option-label--selected"]]: selected
              })}>{`${isBooleanValue(value_2) ? formatMessage(value_2) : value_2} (${count})`}</span>} handleCheckboxChange={() => onFacetValueChange(code, facet)} /></li>;
          })}</ul></div>}</div>;
    $[5] = currencyIso;
    $[6] = facet;
    $[7] = facetName;
    $[8] = formatMessage;
    $[9] = isExpanded;
    $[10] = onFacetRangeChange;
    $[11] = onFacetValueChange;
    $[12] = pageType;
    $[13] = searchInput;
    $[14] = searchQuery;
    $[15] = selectedCodes;
    $[16] = selectedFacet;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}
function _temp3(t0) {
  const {
    value: value_1
  } = t0;
  return value_1.toLowerCase() === "true";
}
function _temp2(a, b) {
  return a.value.localeCompare(b.value);
}
function _temp(v) {
  return v.code;
}
export default FacetComponent;